const VKCH_INTRO = 'vkchintro';
const VKCH_QUIZ = 'vkchquiz';

const VKCH_IP_DATA = 'vkchipdata';

const VKCH_ITINERARY_DATA = 'vkchitinerarydata';

const storageKeys = {
    VKCH_IP_DATA,
    VKCH_INTRO,
    VKCH_QUIZ,
    VKCH_ITINERARY_DATA
};

export default storageKeys;